import { validatePresence, validateLength } from 'ember-changeset-validations/validators';

export default {
  shortBio: [
    validatePresence({ message: 'content_pillars.validations.group.short_bio.presence', presence: true }),
    validateLength({ message: 'content_pillars.validations.group.short_bio.length', min: 3, max: 200 })
  ]
};
